<template>
  <div ref="wrapper"
       class="my-scroll">
    <slot></slot>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
export default {
  components: {},
  data () {
    return {}
  },
  props: {
    // 传入的数据
    data: {
      type: Array,
      default: null
    },
    probeType: {
      type: Number,
      default: 1
    },
    click: {
      type: Boolean,
      default: true
    },
    // 是否监听滚动位置
    listenScroll: {
      type: Boolean,
      default: false
    },
    richText: {
      type: String,
      default: ''
    },
    // 是否开启上拉刷新
    pullup: {
      type: Boolean,
      default: false
    },
    // 滚动前是否触发事件，如：滚动前让输入框失去焦点，避免滚动搜索结果时移动端键盘遮挡
    beforeScroll: {
      type: Boolean,
      default: false
    },
    pulldown: {
      type: Boolean,
      default: false
    },
    // 延迟刷新
    refreshDelay: {
      type: Number,
      default: 20
    },
    cancelScroll: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    data () {
      setTimeout(() => {
        this.refresh()
      }, this.refreshDelay)
    },
    richText () {
      setTimeout(() => {
        this.refresh()
      }, 1000)
    }
  },
  methods: {
    _initScroll () {
      if (!this.$refs.wrapper) {
        return
      }
      this.scroll = new BScroll(this.$refs.wrapper, {
        probeType: this.probeType,
        click: this.click,
        momentum: true,
        bounce: true,
        pullUpLoad: true && this.pullup,
        pullDownRefresh: true && this.pulldown, // 当顶部下拉距离超过阈值
        mouseWheel: true
      })
      // 如果监听滚动事件，则向父组件传递数据
      if (this.listenScroll) {
        const me = this
        this.scroll.on('scroll', (pos) => {
          me.$emit('scroll', pos)
        })
      }
      // 派发上拉刷新事件
      if (this.pullup) {
        this.scroll.on('scrollEnd', () => {
          if (this.scroll.y <= (this.scroll.maxScrollY + 50)) {
            // 滑动到底部
            this.$emit('scrollToEnd')
          }
        })
      }
      // 派发下拉刷新事件
      if (this.pulldown) {
        this.scroll.on('pullingDown', () => {
          this.$emit('pullingToDown')
        })
      }
      // 滚动前是否触发事件
      if (this.beforeScroll) {
        this.scroll.on('beforeScrollStart', (ops) => {
          this.$emit('beforeScroll', ops)
        })
      }
      if (this.cancelScroll) {
        this.scroll.on('scrollCancel', () => {
          this.$emit('scrollCancel')
        })
      }
    },
    enable () {
      this.scroll && this.scroll.enable()
    },
    disable () {
      this.scroll && this.scroll.disable()
    },
    refresh () {
      this.scroll && this.scroll.refresh()
    },
    // 结束下拉
    finishPullDown () {
      this.scroll && this.scroll.finishPullDown()
    },
    // 结束上拉
    finishPullUp () {
      this.scroll && this.scroll.finishPullUp()
    },
    scrollTo () {
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments)
    },
    scrollToElement () {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments)
    }
  },
  created () {
    if (this.richText !== '') {
      setTimeout(() => {
        this.refresh()
      }, 1000)
    }
  },
  mounted () {
    setTimeout(() => {
      this._initScroll()
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
</style>
